import { Organization } from 'lib/types/company';
import { IThemeProperties } from 'lib/types/themes';

export enum LearningCenterMode {
  CLASSROOM = 'CLASSROOM',
  CLASSROOM_PREVIEW = 'CLASSROOM_PREVIEW',
  CMS = 'CMS',
  LEARNING_LIBRARY = 'LEARNING_LIBRARY',
  PREVIEW = 'PREVIEW',
  TRAINING = 'TRAINING',
  EVENT = 'EVENT',
}

export enum LearningCenterUserSettingKey {
  'AUTO_ADVANCE' = 'AUTO_ADVANCE',
  'LANGUAGE' = 'LANGUAGE',
  'TRANSCRIPTS' = 'TRANSCRIPTS',
}

export interface ILearningCenterMetadata {
  userId?: number;
  companyId?: number;
  companyName?: string;
  companyUrlAlias: string;
  isAdmin: boolean;
  isHotlineEnabled: boolean;
  isManagerHubReportTreeDisabled: boolean;
  isPolicyBotAvailable: boolean;
  organization: Organization;
  theme?: IThemeProperties;
  managerHubInfo?: ILearningCenterManagerHubInfo;
  userSettings: ILearningCenterUserSettingsView;
  scormHideEthenaReferences: boolean;
  scormHideRoleAndLocationUpdate: boolean;
  hideFeedbackSlide: boolean;
  hideTimerDisclaimerSlide: boolean;
  ssoConnection?: string;
  hiddenUserSettings: Exclude<
    LearningCenterUserSettingKey,
    LearningCenterUserSettingKey.LANGUAGE
  >[];
  customQuestionsEmail?: string;
  customTechnicalSupportEmail?: string;
}

export interface ILearningCenterManagerHubInfo {
  managerHubUrl: string;
  incompleteTeamMembersCount: number;
}

export interface ILearningCenterUrlParams {
  classroomKey?: string;
  company?: string;
  kioskKey?: string;
  sso?: string;
  scormKey?: string;
}

export interface ILearningCenterUserSettingsView {
  AUTO_ADVANCE: boolean;
  LANGUAGE: string;
  TRANSCRIPTS: boolean;
}

export type LearningCenterUserSettingValue = boolean | string;

export interface ILearningCenterUserSettingOption {
  settingKey: LearningCenterUserSettingKey;
  value: LearningCenterUserSettingValue;
}

export interface ILearningCenterUserSetting {
  key: LearningCenterUserSettingKey;
  value: LearningCenterUserSettingValue;
  orderedOptions?: string[];
}
